<template>
  <div>
    <v-sheet height="100%" tile color="green lighten-4"
      ><v-container>
        <div class="pt-5 pb-5 h1">Testimonials</div>
        <v-row align="center" justify="center">
          <v-col cols="12" md="4" lg="4" sm="6">
            <v-hover v-slot="{ hover }" open-delay="200">
              <v-card
                :elevation="hover ? 16 : 1"
                :class="{ 'on-hover': hover }"
                class="mx-auto pl-5 pr-5 pb-5 pt-5"
                max-width="250"
                color="white"
              >
                <v-img
                  src="@/assets/lk.jpg"
                  height="200px"
                  class="inner-img"
                ></v-img>

                <h2 class="pt-3">James</h2>
                <p>PR Visa Australia</p>
                <h5 class="pt-5">
                  I have successfully obtained a PR visa for Australia though
                  MyEduVisa..
                </h5>
              </v-card>
            </v-hover>
          </v-col>

          <v-col cols="12" md="4" lg="4" sm="6">
            <v-hover v-slot="{ hover }" open-delay="200">
              <v-card
                :elevation="hover ? 16 : 1"
                :class="{ 'on-hover': hover }"
                class="mx-auto pl-5 pr-5 pb-5 pt-5"
                max-width="250"
                color="white"
              >
                <v-img
                  src="@/assets/b.png"
                  height="200px"
                  class="inner-img"
                ></v-img>
                <h2 class="pt-3">Krishna</h2>
                <p>PR Visa Canada</p>
                <h5 class="pt-5">
                  I have successfully obtained a PR visa for Australia though
                  MyEduVisa..
                </h5>
              </v-card></v-hover
            ></v-col
          >
          <v-col cols="12" md="4" lg="4" sm="6">
            <v-hover v-slot="{ hover }" open-delay="200">
              <v-card
                :elevation="hover ? 16 : 1"
                :class="{ 'on-hover': hover }"
                class="mx-auto pl-5 pr-5 pb-5 pt-5"
                max-width="250"
                color="white"
              >
                <v-img
                  src="@/assets/l.jpg"
                  height="200px"
                  class="inner-img"
                ></v-img>

                <h2 class="pt-3">Renuka</h2>
                <p>PR Visa German</p>
                <h5 class="pt-5">
                  I have successfully obtained a PR visa for Australia though
                  MyEduVisa..
                </h5>
              </v-card></v-hover
            ></v-col
          >
        </v-row>
      </v-container>
    </v-sheet>

    <v-sheet height="100%" tile color="green lighten-4"
      ><v-container>
        <v-row align="center" justify="center">
          <v-col cols="12" md="4" lg="4" sm="12">
            <v-hover v-slot="{ hover }" open-delay="200">
              <v-card
                :elevation="hover ? 16 : 1"
                :class="{ 'on-hover': hover }"
                class="mx-auto pl-5 pr-5 pb-5 pt-5"
                max-width="250"
                color="white"
              >
                <v-img
                  src="@/assets/l.jpg"
                  height="200px"
                  class="inner-img"
                ></v-img>

                <h2 class="pt-3">Jenny</h2>
                <p>PR Visa Singapore</p>
                <h5 class="pt-5">
                  I have successfully obtained a PR visa for Australia though
                  MyEduVisa..
                </h5>
              </v-card>
            </v-hover>
          </v-col>

          <v-col cols="12" md="4" lg="4" sm="12">
            <v-hover v-slot="{ hover }" open-delay="200">
              <v-card
                :elevation="hover ? 16 : 1"
                :class="{ 'on-hover': hover }"
                class="mx-auto pl-5 pr-5 pb-5 pt-5"
                max-width="250"
                color="white"
              >
                <v-img
                  src="@/assets/k.jpg"
                  height="200px"
                  class="inner-img"
                ></v-img>

                <h2 class="pt-3">Hamshi</h2>
                <p>PR Visa Malaysia</p>
                <h5 class="pt-5">
                  I have successfully obtained a PR visa for Australia though
                  MyEduVisa..
                </h5>
              </v-card></v-hover
            ></v-col
          >
          <v-col cols="12" md="4" lg="4" sm="12">
            <v-hover v-slot="{ hover }" open-delay="200">
              <v-card
                :elevation="hover ? 16 : 1"
                :class="{ 'on-hover': hover }"
                class="mx-auto pl-5 pr-5 pb-5 pt-5"
                max-width="250"
                color="white"
              >
                <v-img
                  src="@/assets/services.jpg"
                  height="200px"
                  class="inner-img"
                ></v-img>

                <h2 class="pt-3">Butler</h2>
                <p>PR Visa Uk</p>
                <h5 class="pt-5">
                  I have successfully obtained a PR visa for Australia though
                  MyEduVisa..
                </h5>
              </v-card></v-hover
            ></v-col
          >
        </v-row>
        <div class="text-center pt-5">
          <v-btn color="black" dark large rounded outlined>
            <b> More >></b></v-btn
          >
        </div>
      </v-container>
    </v-sheet>
  </div>
</template>
<script>
export default {
  data() {
    return {
      colors: ["secondary", "secondary"],
      cycle: false,
    };
  },
};
</script>
<style scoped>
.h1 {
  text-align: center;
  color: black;
  font-size: 40px;
}
h2 {
  color: black;
  text-align: center;
}
p {
  color: black;
  text-align: center;
  font-size: 12px;
  padding-top: 10px;
}
.inner-img {
  border-radius: 50%;
}
h5 {
  text-align: center;
  color: black;
}
.theme--light .v-card {
  border-bottom: 5px solid #00c853 !important;
  border-top: 5px solid #00c853 !important;
  border-radius: 30px;
}
</style>